import { CrudList } from '../shared/CrudPage';
import { unitService } from '@kss/api';
import type { Unit, UnitCreate, UnitFilter } from '@kss/api';
import { StatusBadge } from '@kss/ui';

/**
 * Units of measure list — wired to /api/Unit/all (live since 2026-05-02).
 * Replaces the prior localStorage stub once the controller shipped.
 */
export default function AllUnits() {
  return (
    <CrudList<Unit, UnitCreate, UnitFilter>
      title="Units of measure"
      newLabel="New unit"
      service={unitService}
      idKey="unitId"
      labelKey="code"
      basePath="/panel/units"
      module="Unit"
      columns={[
        { accessor: 'code', title: 'Code', sortable: true, filterable: true, width: 100 },
        { accessor: 'name', title: 'Name', sortable: true, filterable: true },
        {
          accessor: 'precision',
          title: 'Decimals',
          sortable: true,
          textAlign: 'right',
          width: 100,
          render: (r) => r.precision ?? 0,
        },
        {
          accessor: 'isActive',
          title: 'Status',
          sortable: true,
          render: (r) => <StatusBadge status={r.isActive ? 'active' : 'inactive'} />,
        },
      ]}
    />
  );
}
